import { get as _get } from 'lodash';
import { AuthActions, AuthActionTypes } from '@app-stores/actions/auth.action';
import { CrmUser } from '@app-models/index';
import * as errorHandler from '@app-shared/utils/error-handler';
export interface State {
	user: CrmUser;
	loggedIn: boolean;
	justLoggedOut: boolean;
	access_token: string;
	refresh_token: string;
	expires_in: number;
	accessDate: Date;
	updatePending: boolean;
	updated: boolean;
	changeEmailPending: boolean;
	changeEmailSuccess: boolean;
	verifyEmailPending: boolean;
	verifyEmailSuccess: { email: string };
	error: any;
	languageSelected: boolean;
	loginWithToken: boolean;
}
export const initialState: State = {
	user: null,
	loggedIn: false,
	justLoggedOut: false,
	access_token: null,
	refresh_token: null,
	expires_in: null,
	updated: false,
	accessDate: new Date(),
	updatePending: false,
	changeEmailPending: false,
	changeEmailSuccess: false,
	verifyEmailPending: false,
	verifyEmailSuccess: null,
	error: null,
	languageSelected: false,
	loginWithToken: false
};
export function reducer(state = initialState, action: AuthActions): State {
	switch (action.type) {
		case AuthActionTypes.SetAuthData: {
			if (action.payload) {
				const user = localStorage.getItem('user');
				const currentSite = localStorage.getItem('currentSite');
				const accessToken = localStorage.getItem('access_token');
				return {
					...state
					// user: user ? JSON.parse(user) : null,
					// currentSite: currentSite ? JSON.parse(currentSite) : null,
					// token: accessToken ? accessToken : null,
					// updated: false,
					// accessDate: new Date,
					// error: null,
				};
			} else {
				return initialState;
			}
		}
		case AuthActionTypes.Authenticated: {
			return {
				...state,
				loggedIn: true,
				error: null,
				user: action.payload,
				access_token: null,
				refresh_token: null
			};
		}
		case AuthActionTypes.Logout:
		case AuthActionTypes.LoginFailure:
		case AuthActionTypes.NotAuthenticated: {
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
			localStorage.removeItem('user');
			localStorage.removeItem('language');
			localStorage.removeItem('crm_translation');
			localStorage.removeItem('translationLanguage');
			sessionStorage.setItem('viewAsRole', '');
			return {
				...initialState,
				justLoggedOut: true
			};
		}
		case AuthActionTypes.LoginSuccess: {
			const access_token = action.payload['access_token'];
			const refresh_token = action.payload['refresh_token'];
			const user = JSON.stringify(action.payload['user']);
			// if (action.rememberMe) {
			// 	localStorage.setItem("access_token", access_token);
			// 	localStorage.setItem("refresh_token", refresh_token);
			// 	localStorage.setItem("user", user);
			// } else {
			// 	localStorage.removeItem("access_token");
			// 	localStorage.removeItem("refresh_token");
			// 	localStorage.removeItem("user");
			// 	localStorage.removeItem("language");
			// }
			localStorage.setItem('access_token', access_token);
			localStorage.setItem('refresh_token', refresh_token);
			localStorage.setItem('user', user);
			return {
				...state,
				loggedIn: true,
				user: action.payload['user'],
				access_token: access_token,
				refresh_token: refresh_token,
				accessDate: new Date(),
				loginWithToken: action.withToken,
				languageSelected: true
			};
		}
		case AuthActionTypes.SelectLanguage: {
			return {
				...state,
				languageSelected: true
			};
		}
		case AuthActionTypes.GetUserDetailSuccess: {
			localStorage.setItem('user', JSON.stringify(action.payload));
			return {
				...state,
				user: action.payload,
				loggedIn: true,
				error: null
			};
		}
		case AuthActionTypes.RefreshTokenSuccess: {
			const access_token = action.payload ? action.payload['access_token'] : '';
			if (localStorage.getItem('refresh_token')) {
				if (!access_token) {
					localStorage.removeItem('access_token');
				} else {
					localStorage.setItem('access_token', access_token);
				}
				localStorage.removeItem('refresh_token');
			}
			return {
				...state,
				updated: false,
				access_token: access_token,
				accessDate: new Date()
			};
		}
		case AuthActionTypes.RefreshTokenFailure:
		case AuthActionTypes.LoginFailure:
		case AuthActionTypes.GetUserDetailFailure: {
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
			localStorage.removeItem('user');
			localStorage.removeItem('language');
			localStorage.removeItem('crm_translation');
			localStorage.removeItem('translationLanguage');
			return {
				...state,
				user: null,
				loggedIn: false,
				updated: false,
				error: action.payload ? errorHandler.getHttpError(action.payload) : 'Token expired',
			};
		}
		case AuthActionTypes.Register: {
			return initialState;
		}
		case AuthActionTypes.UpdateSuccess: {
			const user = state.user;
			return {
				...state,
				user: user,
				updated: true,
				error: null
			};
		}
		case AuthActionTypes.UpdateFailure: {
			return {
				...state,
				updated: false,
				error: errorHandler.getHttpError(
					_get(action.payload, ['error']) || action.payload
				)
			};
		}
		case AuthActionTypes.GetUserDetailFailure: {
			return {
				...state,
				error: errorHandler.getHttpError(
					_get(action.payload, ['error']) || action.payload
				)
			};
		}
		case AuthActionTypes.ChangeEmail: {
			return {
				...state,
				changeEmailPending: true,
				changeEmailSuccess: false,
				error: null
			};
		}
		case AuthActionTypes.ChangeEmailSuccess: {
			return {
				...initialState,
				changeEmailSuccess: true
			};
		}
		case AuthActionTypes.ChangeEmailFailure: {
			return {
				...state,
				changeEmailPending: false,
				changeEmailSuccess: false,
				error: errorHandler.getHttpError(
					_get(action.payload, ['error']) || action.payload
				)
			};
		}
		case AuthActionTypes.ChangeUserName: {
			return {
				...state,
				updatePending: true,
				updated: false,
				error: null
			};
		}
		case AuthActionTypes.ChangeUserNameSuccess: {
			const user = { ...state.user, name: action.payload.username };
			return {
				...state,
				user: user,
				updatePending: false,
				updated: true
			};
		}
		case AuthActionTypes.ChangeUserNameFailure: {
			return {
				...state,
				updatePending: false,
				updated: false,
				error: errorHandler.getHttpError(
					_get(action.payload, ['error']) || action.payload
				)
			};
		}
		case AuthActionTypes.VerifyEmail: {
			return {
				...state,
				verifyEmailPending: true,
				verifyEmailSuccess: null,
				error: null
			};
		}
		case AuthActionTypes.VerifyEmailSuccess: {
			return {
				...state,
				verifyEmailPending: false,
				verifyEmailSuccess: action.payload
			};
		}
		case AuthActionTypes.VerifyEmailFailure: {
			return {
				...state,
				verifyEmailPending: false,
				verifyEmailSuccess: null,
				error: errorHandler.getHttpError(
					_get(action.payload, ['error']) || action.payload
				)
			};
		}
		default: {
			return state;
		}
	}
}
export const getUser = (state: State) => state.user;
export const getLoggedIn = (state: State) => state.loggedIn;
export const getAccessToken = (state: State) => state.access_token;
export const getRefreshToken = (state: State) => state.refresh_token;
export const getExpiresIn = (state: State) => state.expires_in;
export const getUpdatePending = (state: State) => state.updatePending;
export const getUpdated = (state: State) => state.updated;
export const getChangeEmailPending = (state: State) => state.changeEmailPending;
export const getChangeEmailSuccess = (state: State) => state.changeEmailSuccess;
export const getChangeUserNamePending = (state: State) => state.updatePending;
export const getChangeUserNameSuccess = (state: State) => state.updated;
export const getVerifyEmailPending = (state: State) => state.verifyEmailPending;
export const getVerifyEmailSuccess = (state: State) => state.verifyEmailSuccess;
export const getError = (state: State) => state.error;
export const getLanguageSelected = (state: State) => state.languageSelected;
export const getLoginWithToken = (state: State) => {return {loginWithToken: state.loginWithToken, user: state.user}};
export const getLogout = (state: State) => state.justLoggedOut;
